module.exports = __webpack_public_path__ + "static/media/5 2 tattoo leg foot floral ornamental lily delicate intricate.1280x1707.f4fb150d.webp";